import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// initial state
const state: mail.state.MailState = {
  folders: {
    items: [],
    totalCount: 0,
    moreAvailable: false,
    nextPageOffset: 0,
  },
  favorites: [],
  emails: null,
  selections: [],
  selectionFrom: null,
  /**
   * 전체 선택 여부
   */
  selectAll: false,
  currentEmail: null,
  search: {
      isAll: false,
      isSearch: false,
      query: '',
      unreadOnly: false,
      sorts: undefined,
      pattern: null,
  },
  toolbar: {
      orientation: 'vertical',
  },
  write: {
      visibles: {
          sender: false,
          to: true,
          cc: true,
          bcc: false,
          file: false,
          bigfile: false,
      },
  },
}

export default {
  state,
  actions,
  getters,
  mutations,
}
